import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import {
  AnnouncementCard,
  type Announcement,
} from "../components/announcement";
import { CMFlex } from "@chartmetric/chartmetric-design-system/components/CMFlex";
import { fetchAnnouncementById } from "../api/announcement";

function PostDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation("common", { keyPrefix: "announcementPanel" });

  const [announcement, setAnnouncement] = useState<Announcement | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const numericId = Number(id);
    if (Number.isNaN(numericId)) {
      setError(t("notFound"));
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    void (async () => {
      try {
        const data = await fetchAnnouncementById(numericId);
        if (!cancelled) {
          setAnnouncement(data);
        }
      } catch {
        if (!cancelled) setError(t("loadError"));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, t]);

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 px-4 py-6">
      <Link to="/" className="text-sm text-cm-teal-600 hover:underline">
        {t("backToList")}
      </Link>
      {loading && (
        <div className="flex items-center justify-center py-12">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-cm-gray-200 border-t-cm-blue-600" />
        </div>
      )}
      {!loading && error && (
        <div className="rounded-md border border-cm-red-300 bg-cm-red-50 p-3 text-sm text-cm-red-700">
          {error}
        </div>
      )}
      {!loading && !error && announcement && (
        <CMFlex background="bg-theme-background">
          <AnnouncementCard announcement={announcement} />
        </CMFlex>
      )}
    </div>
  );
}

export default PostDetailPage;
